module.exports = __webpack_public_path__ + "static/media/IMG_4288.4689486e.PNG";